import { ChevronLeft } from "lucide-react";
import { Button } from "../ui/button";

interface ComponentHeaderProps {
  name: string;
  handleClick: () => void;
  'data-testid'?: string;
}

export const ComponentHeader = ({ name, handleClick, 'data-testid': testId }: ComponentHeaderProps): JSX.Element => {
  return (
    <div className="bg-custom-gradient shadow-custom flex sm:hidden h-[60px] w-full items-center justify-between border-b border-[#d8d8d8] sm:bg-none sm:bg-white px-6 py-2.5">
      <div className="flex items-center gap-2.5">
        <Button
          variant="ghost"
          size="icon"
          onClick={handleClick}
          data-testid={testId}
          className="p-0"
        >
          <ChevronLeft className="h-6 w-6" />
        </Button>
        <h1 className="text-lg font-semibold">{name}</h1>
      </div>
    </div>
  );
};